import { SectionData, sectionTypes } from '@playbooks/action-cards-utils/src'
import Section from './Section'
import SectionWrapper from './SectionWrapper'

interface SectionsProps {
  sections: SectionData[]
  isPinnedView?: boolean
}

export default function Sections({ sections, isPinnedView }: SectionsProps) {
  return sections.map(section => {
    if (section.type === sectionTypes.SEPARATOR) return null
    if (section.type !== sectionTypes.CONTENT) {
      return (
        <div key={section.id} className="text-red-300 bold text-center">
          Section type of [{section.type}] is not supported. Use the [{sectionTypes.CONTENT}] type
        </div>
      )
    }

    return (
      <SectionWrapper key={section.id} section={section} isPinnedView={!!isPinnedView}>
        <Section data={section} />
      </SectionWrapper>
    )
  })
}
